<script setup lang="ts">
import { computed } from "vue";
import * as tooltip from "@zag-js/tooltip";
import { normalizeProps, useMachine } from "@zag-js/vue";
import { bsonId } from "@/common/utils/common";

const props = defineProps<{
  disabled?: boolean;
  position?: any;
}>();

const service = useMachine(tooltip.machine, {
  id: bsonId(),
  positioning: {
    placement: props.position || "bottom",
  },
});

const api = computed(() => tooltip.connect(service, normalizeProps));
</script>

<template>
  <div class="base-tooltip">
    <div
      ref="ref"
      v-bind="api.getTriggerProps()"
      @mouseover="api.setOpen(true)"
      @mouseout="api.setOpen(false)"
    >
      <slot name="trigger"></slot>
    </div>
    <template v-if="!disabled && $slots.tooltip">
      <div v-if="api.open" v-bind="api.getPositionerProps()">
        <div v-bind="api.getContentProps()">
          <slot name="tooltip"></slot>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.base-tooltip {
  position: initial;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: fit-content;

  .trigger {
    display: flex;
    height: min-content;
  }
}

[data-part="content"] {
  background: white;
  color: #000;
  box-shadow: 2px 3px 4px var(--shadow);
  padding-block: 0.2rem;
  padding-inline: 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.9rem;
  border: 1px solid #e7e7e7;
}
</style>
